import React from 'react'

import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'

import { StrategyMemoList } from './components/StrategyMemoList'

export const StrategyMemoListPage = () => {
  useLogEventOnMount('Access to customer strategy list')

  return <StrategyMemoList />
}
